<script>
  import NauiInput from "../../../lib/naui/atoms/NauiInput.svelte";
  import "../../../../static/front/css/lib/astillero/_formAud.css";
  import NauiButton from "../../../lib/naui/atoms/NauiButton.svelte";
  import { writable } from "svelte/store";
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import {maxLenghtInput} from "../../../lib/utils/index";
  import {allowPositiveValues} from "../../../lib/utils/index";
  
  export let data;
  export let hasError;

  const dispatch = createEventDispatcher();

  let numItems = 8;
  let undsArray = writable(Array(numItems).fill(0));
  let descripcionesArray = writable(Array(numItems).fill(""));
  let totalUnitsMedidas = writable(0);

    
  let showWarning = writable(false);
  let showDefectWarning = writable(Array(numItems).fill(false));
  let showUnitsWarning = writable(Array(numItems).fill(false));


  let medidasData = {
    tamano_muestra_medidas: data.tamano_muestra_medidas??0,
    medidas_cantidad_aprueba: data.medidas_cantidad_aprueba,
    medidas_cantidad_rechaza: data.medidas_cantidad_rechaza,
    medidas_estado: data.medidas_estado,
    lista_medidas: [],
    total_unidades_medidas: data.total_unidades_medidas,
  };

  $: {
    totalUnitsMedidas.set(
      $undsArray.reduce((acc, val) => acc + Number(val), 0)
    );
    medidasData.total_unidades_medidas = $totalUnitsMedidas;
    medidasData.lista_medidas = $descripcionesArray
      .map((descripcion, index) => ({
        descripcion: descripcion,
        unidades: $undsArray[index],
      }))
      .filter((item) => item.descripcion !== "" && item.unidades > 0);

    medidasData.medidas_cantidad_rechaza ===""?medidasData.medidas_cantidad_rechaza = null: medidasData.medidas_cantidad_rechaza;
    medidasData.medidas_cantidad_aprueba ===""?medidasData.medidas_cantidad_aprueba = null: medidasData.medidas_cantidad_aprueba;

    //Actualizar estado de las medidas
    if (medidasData.medidas_cantidad_aprueba == null && medidasData.medidas_cantidad_rechaza == null) {
      medidasData.medidas_estado = null;
    } else{
        if (
            medidasData.medidas_cantidad_aprueba &&
            (
              medidasData.total_unidades_medidas <=
              medidasData.medidas_cantidad_aprueba
            )
        ) {
          medidasData.medidas_estado = true;
        } 
        if(
            medidasData.medidas_cantidad_aprueba &&
            (
              medidasData.total_unidades_medidas >
              medidasData.medidas_cantidad_aprueba
            )
          )
        {
          medidasData.medidas_estado = false;
        }
    }

    actualizarDatos();
  }

  $: {
    if (
        (
          $totalUnitsMedidas > 0 && 
          (!medidasData.medidas_cantidad_aprueba || !medidasData.medidas_cantidad_rechaza)
        )
      ) 
    {
      showWarning.set(true);
    } else {
      showWarning.set(false);
    }
  }

  $: {
    showDefectWarning.set(
      $undsArray.map((val, index) => val > 0 && !$descripcionesArray[index])
    );
  }

  $: {
    showUnitsWarning.set(
      $descripcionesArray.map((defecto, index) => defecto && (!$undsArray[index] || $undsArray[index] === 0))
    );
  }

  $:{
    
  }


  //Banderar para saber si hay un error en el módulo
  $: {
    if(
      $showWarning ||
      $showDefectWarning.some((warning) => warning) ||
      $showUnitsWarning.some((warning) => warning)
      ||(medidasData.tamano_muestra_medidas < 1 )
    )
    {
      hasError.update(errors => errors.filter(error => error !== 'Auditoría Medidas'));
      hasError.update(errors => [...errors, 'Auditoría Medidas']);
    }else{
      hasError.update(errors => errors.filter(error => error !== 'Auditoría Medidas'));
    }
  }

  function quitar(index) {
    descripcionesArray.update((arr) => arr.filter((_, i) => i !== index));
    undsArray.update((arr) => arr.filter((_, i) => i !== index));
    numItems--;
  }

  onMount(() => {
    if (data.lista_medidas && data.lista_medidas.length > 0) {
      numItems = data.lista_medidas.length;
      undsArray.set(data.lista_medidas.map((item) => item.unidades));
      descripcionesArray.set(
        data.lista_medidas.map((item) => item.descripcion)
      );
    }
    actualizarDatos();
  });

  const handleItems = () => {
    numItems++;
    undsArray.update((arr) => [...arr, 0]);
    descripcionesArray.update((arr) => [...arr, ""]);
  };

  function actualizarDatos() {
    dispatch("update", { label: "Medidas", data: { ...medidasData } });
  }

</script>

<div class="containerMain">
  <div class="containerMainInt">
    <div class="containerMainIntHeader" style="align-items: normal !important;">
      <div>
        <NauiInput
          class='{medidasData.tamano_muestra_medidas <1 || !medidasData.tamano_muestra_medidas ? "red-border" : ""}'
          label="Tamaño de Muestra"
          type="number"
          bind:value={medidasData.tamano_muestra_medidas}
          on:input={(e)=>{
            medidasData.tamano_muestra_medidas = maxLenghtInput(e, 9);
            actualizarDatos();
          }}
        />
        {#if medidasData.tamano_muestra_medidas <1 || !medidasData.tamano_muestra_medidas}
          <p class="error-message">Este campo es obligatorio</p>
        {/if}
      </div>

      <div class="input-container">
        <NauiInput
        class="{$showWarning && !medidasData.medidas_cantidad_aprueba ? 'red-border' : ''}"
          label="A"
          type="number"
          min=0
          bind:value={medidasData.medidas_cantidad_aprueba}
          on:input={(e) => {
            medidasData.medidas_cantidad_aprueba = maxLenghtInput(e, 9);
            actualizarDatos();
          }}
        />
        {#if $showWarning && !medidasData.medidas_cantidad_aprueba}
          <p class="error-message">Este campo es obligatorio</p>
        {/if}
      </div>

      <div>
        <NauiInput
          class="{$showWarning && !medidasData.medidas_cantidad_rechaza ? 'red-border' : ''}"
          label="R"
          type="number"
          min=0
          bind:value={medidasData.medidas_cantidad_rechaza}
          on:input={(e) => {
            medidasData.medidas_cantidad_rechaza = maxLenghtInput(e, 9);
            actualizarDatos();
          }}
        />
        {#if $showWarning && !medidasData.medidas_cantidad_rechaza}
          <p class="error-message">Este campo es obligatorio</p>
        {/if}
      </div>
      
      <div class="checkConf">
        <label for="aMedida_{data.id}">A</label>
        <input
          type="radio"
          name="medidaEstado_{data.id}"
          id="aMedida_{data.id}"
          value={true}
          bind:group={medidasData.medidas_estado}
          disabled
        />
        <label for="rMedida_{data.id}">R</label>
        <input
          type="radio"
          name="medidaEstado_{data.id}"
          id="rMedida_{data.id}"
          value={false}
          bind:group={medidasData.medidas_estado}
          disabled
        />
      </div>

      <NauiInput
        label="Totales defectuosas"
        type="text"
        isDisabled={true}
        bind:value={$totalUnitsMedidas}
      />
    </div>

    <div class="containerMainIntBody">
      <div class="addItem">
        <NauiButton
          caption="+"
          mode="outline"
          color="accent"
          on:click={handleItems}
        />
      </div>
      <div class="containerMainIntBodyList" style="align-items: normal !important;">
        {#each Array.from({ length: numItems }) as _, i}
          <div class="item">
            <NauiButton
              icon="disabled_by_default"
              mode="outline"
              color="accent"
              iconStyle="outlined"
              on:click={() => quitar(i)}
            />
            <div class="itemDescrip">
              <p class="tittle-text">Defecto-Talla {i + 1}</p>
              <NauiInput
                class="{$showDefectWarning[i] ? 'red-border' : ''}"
                label=""
                type="text"
                bind:value={$descripcionesArray[i]}
                on:input={(e) => {
                  maxLenghtInput(e, 255);
                }}
              />
              {#if $showDefectWarning[i]}
                <p class="error-message">Este campo es Obligatorio</p>
              {/if}
            </div>
            <div class="units">
              <p class="tittle-text">UNDS</p>
                <NauiInput
                  class="{$showUnitsWarning[i] ? 'red-border' : ''}"
                  label=""
                  type="number"
                  bind:value={$undsArray[i]}
                  on:input={(e) => {
                    allowPositiveValues(e);
                    $undsArray[i] = maxLenghtInput(e, 9);
                  }}
                />
              {#if $showUnitsWarning[i]}
                <p class="error-message">Ingrese una cantidad válida</p>
              {/if}
            </div>
          </div>
        {/each}
      </div>
    </div>
  </div>
</div>

<style>
  .checkConf {
    width: 10%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: flex-start!important;
    margin-bottom: 5px;
  }

  .itemDescrip {
    width: 80%;
  }

  .units {
    width: 16%;
  }

  @media (max-width: 930px) {
    .muestra-content {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 3fr);
      gap: 15px;
    }
    .checks {
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 50%;
    }
  }

  :global(.red-border.naui-field input label) {
    border: 1px solid #ff5a5f;
  }
  :global(.red-border.naui-field.active label) {
    color: red;
  }

</style>
